import AuthService from "./AuthService"
import ApiService from "./ApiService";

class AddProductService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._mainCategoriesUrl = '/add-product/info/main-categories';
        this._subCategoriesUrl = '/add-product/info/sub-categories';
        this._manufacturersUrl = '/add-product/info/manufacturers';
        this._packingTypeUrl = '/add-product/info/packs';
        this._quantityUnitsUrl = '/add-product/info/quantity-units';
        this._attributesUrl = '/add-product/info/attributes';
        this._paymentWaysUrl = '/add-product/info/payment-ways';
        this._createProductUrl = '/add-product/create';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    create(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._createProductUrl, data, headers);
    }

    getMainCategories() {
        return this.postResource(this._mainCategoriesUrl, {}, this.getLangHeader())
    }

    getSubCategories(parentId) {
        return this.postResource(this._subCategoriesUrl, {categoryId: parentId}, this.getLangHeader())
    }

    getManufacturers(parentId) {
        return this.postResource(this._manufacturersUrl, {categoryId: parentId}, this.getLangHeader())
    }

    getPackingType(parentId) {
        return this.postResource(this._packingTypeUrl, {categoryId: parentId}, this.getLangHeader())
    }

    getQuantityUnits(parentId) {
        return this.postResource(this._quantityUnitsUrl, {categoryId: parentId}, this.getLangHeader())
    }

    getCategoryAttributes(id) {
        return this.postResource(this._attributesUrl, {categoryId: id}, this.getLangHeader())
    }

    getPaymentWays() {
        return this.postResource(this._paymentWaysUrl, {}, this.getLangHeader())
    }
}

const addProductService = new AddProductService(AuthService);

export default addProductService;
